import {
  isQuotingToolAvailable,
  hasProcessPermission,
} from 'modules/common/permissions';

import { initProfitItemDetailsPage } from './detailsPage/data/sagas';
import ProfitItemDetailsPage from './detailsPage/entry';
import { initProfitItemsListPage } from './listPage/data/sagas';
import ProfitItemsListPage from './listPage/entry';

export default [
  {
    component: ProfitItemsListPage,
    exact: true,
    name: 'profitItemsListPage',
    path: '/processes/pricing',
    helpId: 'pricing_list',
    permissions: [isQuotingToolAvailable, hasProcessPermission],
    saga: initProfitItemsListPage,
  },
  {
    component: ProfitItemDetailsPage,
    exact: true,
    name: 'profitItemDetailsPage',
    path: '/processes/pricing/:profitItemId',
    helpId: 'profit_item_details',
    permissions: [isQuotingToolAvailable, hasProcessPermission],
    saga: initProfitItemDetailsPage,
  },
];
